import React, { useState } from "react";
import { ChiTietTaiSan1 } from "../ChiTiet/ChiTietTaiSan";

export const BtnChiTietTaiSan = ({ item }) => {
  const [showChiTietTaiSan, setShowChiTietTaiSan] = useState(false);
  const handleCloseChiTietTaiSan = () => setShowChiTietTaiSan(false);
  const handleShowChiTietTaiSan = () => setShowChiTietTaiSan(true);
  const functionChiTietTaiSan = () => {
    setShowChiTietTaiSan(true);
  };

  return (
    <>
      <a href={() => false} className="blue btn-link" onClick={functionChiTietTaiSan}>
        {item.TenTaiSan}
      </a>
      {showChiTietTaiSan && (
        <ChiTietTaiSan1
          show={showChiTietTaiSan}
          taiSanId={item.TaiSanID}
          onHide={handleCloseChiTietTaiSan}
        ></ChiTietTaiSan1>
      )}
    </>
  );
};
